import React, { Component } from "react";
import styled from "styled-components";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Row,
  InputGroup,
  Form,
  CardHeader,
} from "reactstrap";
import Breadcrumbs from "../../../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import FormToFilterReport from "../../../../../components/forms/FormToFilterReport";
import CustomBarChart from "../../../../../components/Charts/barChart";
import DountChart from "../../../../../components/Charts/dountChart";
import Flatpickr from "react-flatpickr";
import CustomSplineArea from "../../../../../components/Charts/splineArea";
import { getCurrentDay, getSelectedDaysAgo } from "../../../../../helpers/utils";
import { getOffers } from "../../../../../store/offers/actions";

class ClientReports extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    return (
      <React.Fragment>
        <Row>
          <Col xl={6}>
            <StyledCard>
              <CardBody>
                <Row className="justify-content-between align-middle">
                  <Col xs={6}>
                    <h5 className="fw-bold">Campaigns count by client</h5>
                  </Col>
                </Row>
                <DountChart
                  data={this.props.countByClient}
                  categories={["client_id"]}
                  yaxisName="Client Campaigns Count"
                  typeChart="donut" // or pie
                  currency=""
                />
              </CardBody>
            </StyledCard>
          </Col>
          <Col xl={6}>
            <StyledCard>
              <CardBody>
                <Row className="justify-content-between align-middle">
                  <Col xs={6}>
                    <h5 className="fw-bold">Client campaigns spend</h5>
                  </Col>
                </Row>
                <DountChart
                  data={this.props.clientSpend}
                  categories={["client_id"]}
                  yaxisName="Client Spend"
                  typeChart="donut" // or pie
                  currency="$"
                />
              </CardBody>
            </StyledCard>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

const StyledCard = styled(Card)`
  border: 2px solid rgba(0, 0, 0, 0.05);
`;

ClientReports.propTypes = {
  countByClient: PropTypes.any,
  clientSpend: PropTypes.any,
};

export default connect()(ClientReports);
